import * as Moment from 'moment'
import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Sortable from '../../components/sortable'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Holidays from './holidays'
import * as Types from './types'

interface SchedulePayload {
  holidays: Sortable.SortableData<Holidays.Holiday>,
  schedules: Sortable.SortableData<Types.Schedule>,
}

const scheduleNormalizer: Sortable.TypeNormalizer<Types.Schedule> =
  (payload: SchedulePayload): Sortable.SortableData<Types.Schedule> => {
  return payload.schedules.map((s: Types.Schedule) => ({
    ...s,
    created_datetime: Moment(s.created),
    frequency: s.frequency.toLowerCase(),
    updated_datetime: Moment(s.updated),
  }))
}

const emptyViewState: Types.ScheduleViewState = {
  filter: IsActive.FILTER_STATUS_ACTIVE,
  isLoading: false,
  sort: [],
}

const reducerEvent: Sortable.ReducerEvent<Types.Schedule> = {
  normalizer: scheduleNormalizer,
  requestEvent: Constants.FETCH_SCHEDULES,
}

const modalReducerEvent: Modal.ReducerEvent<{}> = {
  initializeState: () => ({}),
  requestEvent: Constants.MODAL_SCHEDULE,
  toggleEvent: Actions.FormConstants[Form.ENTER],
}

export const reducer = Redux.combineReducers({
  data: IsActive.chainedReducer(Sortable.stateReducer(reducerEvent), Constants.UPDATE_SCHEDULE),
  form: Form.createReducer(Constants.MODAL_SCHEDULE),
  holidays: Holidays.reducer,
  modal: Modal.reducer(modalReducerEvent),
  view: IsActive.filterReducer(
    Sortable.viewReducer(reducerEvent), Constants.FETCH_SCHEDULES, emptyViewState),
})



// WEBPACK FOOTER //
// ./src/pages/schedules/reducer.tsx